import { dequal } from "dequal";
import type { DependencyList, EffectCallback } from "react";
import { useMemo, useRef } from "react";

import { useUpdateEffect } from "common/utilities/useUpdateEffect";

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useDeepMemo = <T>(factory: () => T, deps: DependencyList): T => useMemo(factory, useDeep(deps));

export const useDeepUpdateEffect = (effect: EffectCallback, deps: DependencyList) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useUpdateEffect(effect, useDeep(deps));

const useDeep = (deps: DependencyList) => {
  const depsRef = useRef<DependencyList>([]);

  if (!dequal(deps, depsRef.current)) depsRef.current = deps;

  return depsRef.current;
};
